import type {EditedProperty} from 'src/typings';
import {transferify} from 'shared/utils/data-service-utils';
import type {DvkStatsData, DvkStatsDataParams, PublicStatsData, PublicStatsDataParams, ZStatsData} from './types';
import type {AjaxService} from 'core/data-services/ajax.service';

export class StatsDataService {
    public static serviceName = 'statsDataService';

    public static readonly PUBLIC_STATS_ROUTE = 'stats/public';
    public static readonly PUBLIC_STATS_FORM_SETTINGS_ROUTE = 'stats/public/formSettings';
    public static readonly DVK_STATS_ROUTE = 'stats/dvk';
    public static readonly DVK_STATS_FORM_SETTINGS_ROUTE = 'stats/dvk/form';
    public static readonly Z_STATS_ROUTE = 'stats/z';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    public async getPublicStats(params?: PublicStatsDataParams): Promise<PublicStatsData> {
        return this.ajaxService
            .createRequest(StatsDataService.PUBLIC_STATS_ROUTE)
            .get({...transferify(params)});
    }

    public async getPublicStatsFormSettings(): Promise<EditedProperty[]> {
        return this.ajaxService
            .createRequest(StatsDataService.PUBLIC_STATS_FORM_SETTINGS_ROUTE)
            .get();
    }

    public async getDvkStats(params?: DvkStatsDataParams): Promise<DvkStatsData> {
        return this.ajaxService
            .createRequest(StatsDataService.DVK_STATS_ROUTE)
            .get({...transferify(params)});
    }

    public async getDvkStatsFormSettings(): Promise<EditedProperty[]> {
        return this.ajaxService
            .createRequest(StatsDataService.DVK_STATS_FORM_SETTINGS_ROUTE)
            .get();
    }

    public async getZStatsData(): Promise<ZStatsData> {
        return this.ajaxService
            .createRequest(StatsDataService.Z_STATS_ROUTE)
            .get();
    }
}